import * as React from "react";
const BlogSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="rgba(238, 65, 55, 1)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 6s-1.5-2-5-2-5 2-5 2v14s1.5-1 5-1 5 1 5 1m0-14v14m0-14s1.5-2 5-2 5 2 5 2v14s-1.5-1-5-1-5 1-5 1"
    />
  </svg>
);
export default BlogSVG;
